export default __webpack_public_path__ + "past_dose.png";